/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as AuthenticatedUserImport } from './routes/_authenticated-user'
import { Route as AuthenticatedActorImport } from './routes/_authenticated-actor'
import { Route as IndexImport } from './routes/index'
import { Route as NyBrukerIndexImport } from './routes/ny-bruker/index'
import { Route as LoginIndexImport } from './routes/login/index'
import { Route as AuthenticatedUserSmsMeldingerIndexImport } from './routes/_authenticated-user/sms-meldinger/index'
import { Route as AuthenticatedActorSignerIndexImport } from './routes/_authenticated-actor/signer/index'
import { Route as AuthenticatedUserSuperuserTinglysingIndexImport } from './routes/_authenticated-user/superuser/tinglysing/index'
import { Route as AuthenticatedUserSuperuserStatistikkIndexImport } from './routes/_authenticated-user/superuser/statistikk/index'
import { Route as AuthenticatedUserSuperuserRapporterIndexImport } from './routes/_authenticated-user/superuser/rapporter/index'
import { Route as AuthenticatedUserSuperuserAfpantIndexImport } from './routes/_authenticated-user/superuser/afpant/index'
import { Route as AuthenticatedUserOppdragTluxCaseIdIndexImport } from './routes/_authenticated-user/oppdrag/$tluxCaseId/index'
import { Route as AuthenticatedUserSuperuserAfpantOrgNumberIndexImport } from './routes/_authenticated-user/superuser/afpant/$orgNumber/index'
import { Route as AuthenticatedUserOppdragTluxCaseIdOpprettSlettingIndexImport } from './routes/_authenticated-user/oppdrag/$tluxCaseId/opprett-sletting/index'
import { Route as AuthenticatedUserOppdragTluxCaseIdOpprettSkjteIndexImport } from './routes/_authenticated-user/oppdrag/$tluxCaseId/opprett-skjøte/index'
import { Route as AuthenticatedUserOppdragTluxCaseIdOpprettSikringIndexImport } from './routes/_authenticated-user/oppdrag/$tluxCaseId/opprett-sikring/index'
import { Route as AuthenticatedUserOppdragTluxCaseIdOpprettHjemmelserklringIndexImport } from './routes/_authenticated-user/oppdrag/$tluxCaseId/opprett-hjemmelserklæring/index'
import { Route as AuthenticatedUserOppdragTluxCaseIdSlettingSlettingIdIndexImport } from './routes/_authenticated-user/oppdrag/$tluxCaseId/sletting/$slettingId/index'
import { Route as AuthenticatedUserOppdragTluxCaseIdSkjteSkjteIdIndexImport } from './routes/_authenticated-user/oppdrag/$tluxCaseId/skjøte/$skjøteId/index'
import { Route as AuthenticatedUserOppdragTluxCaseIdSikringSikringIdIndexImport } from './routes/_authenticated-user/oppdrag/$tluxCaseId/sikring/$sikringId/index'
import { Route as AuthenticatedUserOppdragTluxCaseIdHjemmelserklringHjemmelserklringIdIndexImport } from './routes/_authenticated-user/oppdrag/$tluxCaseId/hjemmelserklæring/$hjemmelserklæringId/index'
import { Route as AuthenticatedUserSuperuserAfpantOrgNumberUtboksfilOutboxFileIdIndexImport } from './routes/_authenticated-user/superuser/afpant/$orgNumber/utboksfil/$outboxFileId/index'
import { Route as AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentsvarPantedokumentResponseIdIndexImport } from './routes/_authenticated-user/superuser/afpant/$orgNumber/pantedokumentsvar/$pantedokumentResponseId/index'
import { Route as AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentPantedokumentIdIndexImport } from './routes/_authenticated-user/superuser/afpant/$orgNumber/pantedokument/$pantedokumentId/index'
import { Route as AuthenticatedUserSuperuserAfpantOrgNumberIntensjonssvarIntentionMessageResponseIdIndexImport } from './routes/_authenticated-user/superuser/afpant/$orgNumber/intensjonssvar/$intentionMessageResponseId/index'
import { Route as AuthenticatedUserSuperuserAfpantOrgNumberIntensjonsmeldingIntentionMessageIdIndexImport } from './routes/_authenticated-user/superuser/afpant/$orgNumber/intensjonsmelding/$intentionMessageId/index'
import { Route as AuthenticatedUserSuperuserAfpantOrgNumberInnboksfilInboxFileIdIndexImport } from './routes/_authenticated-user/superuser/afpant/$orgNumber/innboksfil/$inboxFileId/index'

// Create/Update Routes

const AuthenticatedUserRoute = AuthenticatedUserImport.update({
  id: '/_authenticated-user',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedActorRoute = AuthenticatedActorImport.update({
  id: '/_authenticated-actor',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const NyBrukerIndexRoute = NyBrukerIndexImport.update({
  id: '/ny-bruker/',
  path: '/ny-bruker/',
  getParentRoute: () => rootRoute,
} as any)

const LoginIndexRoute = LoginIndexImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedUserSmsMeldingerIndexRoute =
  AuthenticatedUserSmsMeldingerIndexImport.update({
    id: '/sms-meldinger/',
    path: '/sms-meldinger/',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)

const AuthenticatedActorSignerIndexRoute =
  AuthenticatedActorSignerIndexImport.update({
    id: '/signer/',
    path: '/signer/',
    getParentRoute: () => AuthenticatedActorRoute,
  } as any)

const AuthenticatedUserSuperuserTinglysingIndexRoute =
  AuthenticatedUserSuperuserTinglysingIndexImport.update({
    id: '/superuser/tinglysing/',
    path: '/superuser/tinglysing/',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)

const AuthenticatedUserSuperuserStatistikkIndexRoute =
  AuthenticatedUserSuperuserStatistikkIndexImport.update({
    id: '/superuser/statistikk/',
    path: '/superuser/statistikk/',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)

const AuthenticatedUserSuperuserRapporterIndexRoute =
  AuthenticatedUserSuperuserRapporterIndexImport.update({
    id: '/superuser/rapporter/',
    path: '/superuser/rapporter/',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)

const AuthenticatedUserSuperuserAfpantIndexRoute =
  AuthenticatedUserSuperuserAfpantIndexImport.update({
    id: '/superuser/afpant/',
    path: '/superuser/afpant/',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)

const AuthenticatedUserOppdragTluxCaseIdIndexRoute =
  AuthenticatedUserOppdragTluxCaseIdIndexImport.update({
    id: '/oppdrag/$tluxCaseId/',
    path: '/oppdrag/$tluxCaseId/',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)

const AuthenticatedUserSuperuserAfpantOrgNumberIndexRoute =
  AuthenticatedUserSuperuserAfpantOrgNumberIndexImport.update({
    id: '/superuser/afpant/$orgNumber/',
    path: '/superuser/afpant/$orgNumber/',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)

const AuthenticatedUserOppdragTluxCaseIdOpprettSlettingIndexRoute =
  AuthenticatedUserOppdragTluxCaseIdOpprettSlettingIndexImport.update({
    id: '/oppdrag/$tluxCaseId/opprett-sletting/',
    path: '/oppdrag/$tluxCaseId/opprett-sletting/',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)

const AuthenticatedUserOppdragTluxCaseIdOpprettSkjteIndexRoute =
  AuthenticatedUserOppdragTluxCaseIdOpprettSkjteIndexImport.update({
    id: '/oppdrag/$tluxCaseId/opprett-skjøte/',
    path: '/oppdrag/$tluxCaseId/opprett-skjøte/',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)

const AuthenticatedUserOppdragTluxCaseIdOpprettSikringIndexRoute =
  AuthenticatedUserOppdragTluxCaseIdOpprettSikringIndexImport.update({
    id: '/oppdrag/$tluxCaseId/opprett-sikring/',
    path: '/oppdrag/$tluxCaseId/opprett-sikring/',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)

const AuthenticatedUserOppdragTluxCaseIdOpprettHjemmelserklringIndexRoute =
  AuthenticatedUserOppdragTluxCaseIdOpprettHjemmelserklringIndexImport.update({
    id: '/oppdrag/$tluxCaseId/opprett-hjemmelserklæring/',
    path: '/oppdrag/$tluxCaseId/opprett-hjemmelserklæring/',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)

const AuthenticatedUserOppdragTluxCaseIdSlettingSlettingIdIndexRoute =
  AuthenticatedUserOppdragTluxCaseIdSlettingSlettingIdIndexImport.update({
    id: '/oppdrag/$tluxCaseId/sletting/$slettingId/',
    path: '/oppdrag/$tluxCaseId/sletting/$slettingId/',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)

const AuthenticatedUserOppdragTluxCaseIdSkjteSkjteIdIndexRoute =
  AuthenticatedUserOppdragTluxCaseIdSkjteSkjteIdIndexImport.update({
    id: '/oppdrag/$tluxCaseId/skjøte/$skjøteId/',
    path: '/oppdrag/$tluxCaseId/skjøte/$skjøteId/',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)

const AuthenticatedUserOppdragTluxCaseIdSikringSikringIdIndexRoute =
  AuthenticatedUserOppdragTluxCaseIdSikringSikringIdIndexImport.update({
    id: '/oppdrag/$tluxCaseId/sikring/$sikringId/',
    path: '/oppdrag/$tluxCaseId/sikring/$sikringId/',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)

const AuthenticatedUserOppdragTluxCaseIdHjemmelserklringHjemmelserklringIdIndexRoute =
  AuthenticatedUserOppdragTluxCaseIdHjemmelserklringHjemmelserklringIdIndexImport.update(
    {
      id: '/oppdrag/$tluxCaseId/hjemmelserklæring/$hjemmelserklæringId/',
      path: '/oppdrag/$tluxCaseId/hjemmelserklæring/$hjemmelserklæringId/',
      getParentRoute: () => AuthenticatedUserRoute,
    } as any,
  )

const AuthenticatedUserSuperuserAfpantOrgNumberUtboksfilOutboxFileIdIndexRoute =
  AuthenticatedUserSuperuserAfpantOrgNumberUtboksfilOutboxFileIdIndexImport.update(
    {
      id: '/superuser/afpant/$orgNumber/utboksfil/$outboxFileId/',
      path: '/superuser/afpant/$orgNumber/utboksfil/$outboxFileId/',
      getParentRoute: () => AuthenticatedUserRoute,
    } as any,
  )

const AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentsvarPantedokumentResponseIdIndexRoute =
  AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentsvarPantedokumentResponseIdIndexImport.update(
    {
      id: '/superuser/afpant/$orgNumber/pantedokumentsvar/$pantedokumentResponseId/',
      path: '/superuser/afpant/$orgNumber/pantedokumentsvar/$pantedokumentResponseId/',
      getParentRoute: () => AuthenticatedUserRoute,
    } as any,
  )

const AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentPantedokumentIdIndexRoute =
  AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentPantedokumentIdIndexImport.update(
    {
      id: '/superuser/afpant/$orgNumber/pantedokument/$pantedokumentId/',
      path: '/superuser/afpant/$orgNumber/pantedokument/$pantedokumentId/',
      getParentRoute: () => AuthenticatedUserRoute,
    } as any,
  )

const AuthenticatedUserSuperuserAfpantOrgNumberIntensjonssvarIntentionMessageResponseIdIndexRoute =
  AuthenticatedUserSuperuserAfpantOrgNumberIntensjonssvarIntentionMessageResponseIdIndexImport.update(
    {
      id: '/superuser/afpant/$orgNumber/intensjonssvar/$intentionMessageResponseId/',
      path: '/superuser/afpant/$orgNumber/intensjonssvar/$intentionMessageResponseId/',
      getParentRoute: () => AuthenticatedUserRoute,
    } as any,
  )

const AuthenticatedUserSuperuserAfpantOrgNumberIntensjonsmeldingIntentionMessageIdIndexRoute =
  AuthenticatedUserSuperuserAfpantOrgNumberIntensjonsmeldingIntentionMessageIdIndexImport.update(
    {
      id: '/superuser/afpant/$orgNumber/intensjonsmelding/$intentionMessageId/',
      path: '/superuser/afpant/$orgNumber/intensjonsmelding/$intentionMessageId/',
      getParentRoute: () => AuthenticatedUserRoute,
    } as any,
  )

const AuthenticatedUserSuperuserAfpantOrgNumberInnboksfilInboxFileIdIndexRoute =
  AuthenticatedUserSuperuserAfpantOrgNumberInnboksfilInboxFileIdIndexImport.update(
    {
      id: '/superuser/afpant/$orgNumber/innboksfil/$inboxFileId/',
      path: '/superuser/afpant/$orgNumber/innboksfil/$inboxFileId/',
      getParentRoute: () => AuthenticatedUserRoute,
    } as any,
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated-actor': {
      id: '/_authenticated-actor'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedActorImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated-user': {
      id: '/_authenticated-user'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedUserImport
      parentRoute: typeof rootRoute
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginIndexImport
      parentRoute: typeof rootRoute
    }
    '/ny-bruker/': {
      id: '/ny-bruker/'
      path: '/ny-bruker'
      fullPath: '/ny-bruker'
      preLoaderRoute: typeof NyBrukerIndexImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated-actor/signer/': {
      id: '/_authenticated-actor/signer/'
      path: '/signer'
      fullPath: '/signer'
      preLoaderRoute: typeof AuthenticatedActorSignerIndexImport
      parentRoute: typeof AuthenticatedActorImport
    }
    '/_authenticated-user/sms-meldinger/': {
      id: '/_authenticated-user/sms-meldinger/'
      path: '/sms-meldinger'
      fullPath: '/sms-meldinger'
      preLoaderRoute: typeof AuthenticatedUserSmsMeldingerIndexImport
      parentRoute: typeof AuthenticatedUserImport
    }
    '/_authenticated-user/oppdrag/$tluxCaseId/': {
      id: '/_authenticated-user/oppdrag/$tluxCaseId/'
      path: '/oppdrag/$tluxCaseId'
      fullPath: '/oppdrag/$tluxCaseId'
      preLoaderRoute: typeof AuthenticatedUserOppdragTluxCaseIdIndexImport
      parentRoute: typeof AuthenticatedUserImport
    }
    '/_authenticated-user/superuser/afpant/': {
      id: '/_authenticated-user/superuser/afpant/'
      path: '/superuser/afpant'
      fullPath: '/superuser/afpant'
      preLoaderRoute: typeof AuthenticatedUserSuperuserAfpantIndexImport
      parentRoute: typeof AuthenticatedUserImport
    }
    '/_authenticated-user/superuser/rapporter/': {
      id: '/_authenticated-user/superuser/rapporter/'
      path: '/superuser/rapporter'
      fullPath: '/superuser/rapporter'
      preLoaderRoute: typeof AuthenticatedUserSuperuserRapporterIndexImport
      parentRoute: typeof AuthenticatedUserImport
    }
    '/_authenticated-user/superuser/statistikk/': {
      id: '/_authenticated-user/superuser/statistikk/'
      path: '/superuser/statistikk'
      fullPath: '/superuser/statistikk'
      preLoaderRoute: typeof AuthenticatedUserSuperuserStatistikkIndexImport
      parentRoute: typeof AuthenticatedUserImport
    }
    '/_authenticated-user/superuser/tinglysing/': {
      id: '/_authenticated-user/superuser/tinglysing/'
      path: '/superuser/tinglysing'
      fullPath: '/superuser/tinglysing'
      preLoaderRoute: typeof AuthenticatedUserSuperuserTinglysingIndexImport
      parentRoute: typeof AuthenticatedUserImport
    }
    '/_authenticated-user/oppdrag/$tluxCaseId/opprett-hjemmelserklæring/': {
      id: '/_authenticated-user/oppdrag/$tluxCaseId/opprett-hjemmelserklæring/'
      path: '/oppdrag/$tluxCaseId/opprett-hjemmelserklæring'
      fullPath: '/oppdrag/$tluxCaseId/opprett-hjemmelserklæring'
      preLoaderRoute: typeof AuthenticatedUserOppdragTluxCaseIdOpprettHjemmelserklringIndexImport
      parentRoute: typeof AuthenticatedUserImport
    }
    '/_authenticated-user/oppdrag/$tluxCaseId/opprett-sikring/': {
      id: '/_authenticated-user/oppdrag/$tluxCaseId/opprett-sikring/'
      path: '/oppdrag/$tluxCaseId/opprett-sikring'
      fullPath: '/oppdrag/$tluxCaseId/opprett-sikring'
      preLoaderRoute: typeof AuthenticatedUserOppdragTluxCaseIdOpprettSikringIndexImport
      parentRoute: typeof AuthenticatedUserImport
    }
    '/_authenticated-user/oppdrag/$tluxCaseId/opprett-skjøte/': {
      id: '/_authenticated-user/oppdrag/$tluxCaseId/opprett-skjøte/'
      path: '/oppdrag/$tluxCaseId/opprett-skjøte'
      fullPath: '/oppdrag/$tluxCaseId/opprett-skjøte'
      preLoaderRoute: typeof AuthenticatedUserOppdragTluxCaseIdOpprettSkjteIndexImport
      parentRoute: typeof AuthenticatedUserImport
    }
    '/_authenticated-user/oppdrag/$tluxCaseId/opprett-sletting/': {
      id: '/_authenticated-user/oppdrag/$tluxCaseId/opprett-sletting/'
      path: '/oppdrag/$tluxCaseId/opprett-sletting'
      fullPath: '/oppdrag/$tluxCaseId/opprett-sletting'
      preLoaderRoute: typeof AuthenticatedUserOppdragTluxCaseIdOpprettSlettingIndexImport
      parentRoute: typeof AuthenticatedUserImport
    }
    '/_authenticated-user/superuser/afpant/$orgNumber/': {
      id: '/_authenticated-user/superuser/afpant/$orgNumber/'
      path: '/superuser/afpant/$orgNumber'
      fullPath: '/superuser/afpant/$orgNumber'
      preLoaderRoute: typeof AuthenticatedUserSuperuserAfpantOrgNumberIndexImport
      parentRoute: typeof AuthenticatedUserImport
    }
    '/_authenticated-user/oppdrag/$tluxCaseId/hjemmelserklæring/$hjemmelserklæringId/': {
      id: '/_authenticated-user/oppdrag/$tluxCaseId/hjemmelserklæring/$hjemmelserklæringId/'
      path: '/oppdrag/$tluxCaseId/hjemmelserklæring/$hjemmelserklæringId'
      fullPath: '/oppdrag/$tluxCaseId/hjemmelserklæring/$hjemmelserklæringId'
      preLoaderRoute: typeof AuthenticatedUserOppdragTluxCaseIdHjemmelserklringHjemmelserklringIdIndexImport
      parentRoute: typeof AuthenticatedUserImport
    }
    '/_authenticated-user/oppdrag/$tluxCaseId/sikring/$sikringId/': {
      id: '/_authenticated-user/oppdrag/$tluxCaseId/sikring/$sikringId/'
      path: '/oppdrag/$tluxCaseId/sikring/$sikringId'
      fullPath: '/oppdrag/$tluxCaseId/sikring/$sikringId'
      preLoaderRoute: typeof AuthenticatedUserOppdragTluxCaseIdSikringSikringIdIndexImport
      parentRoute: typeof AuthenticatedUserImport
    }
    '/_authenticated-user/oppdrag/$tluxCaseId/skjøte/$skjøteId/': {
      id: '/_authenticated-user/oppdrag/$tluxCaseId/skjøte/$skjøteId/'
      path: '/oppdrag/$tluxCaseId/skjøte/$skjøteId'
      fullPath: '/oppdrag/$tluxCaseId/skjøte/$skjøteId'
      preLoaderRoute: typeof AuthenticatedUserOppdragTluxCaseIdSkjteSkjteIdIndexImport
      parentRoute: typeof AuthenticatedUserImport
    }
    '/_authenticated-user/oppdrag/$tluxCaseId/sletting/$slettingId/': {
      id: '/_authenticated-user/oppdrag/$tluxCaseId/sletting/$slettingId/'
      path: '/oppdrag/$tluxCaseId/sletting/$slettingId'
      fullPath: '/oppdrag/$tluxCaseId/sletting/$slettingId'
      preLoaderRoute: typeof AuthenticatedUserOppdragTluxCaseIdSlettingSlettingIdIndexImport
      parentRoute: typeof AuthenticatedUserImport
    }
    '/_authenticated-user/superuser/afpant/$orgNumber/innboksfil/$inboxFileId/': {
      id: '/_authenticated-user/superuser/afpant/$orgNumber/innboksfil/$inboxFileId/'
      path: '/superuser/afpant/$orgNumber/innboksfil/$inboxFileId'
      fullPath: '/superuser/afpant/$orgNumber/innboksfil/$inboxFileId'
      preLoaderRoute: typeof AuthenticatedUserSuperuserAfpantOrgNumberInnboksfilInboxFileIdIndexImport
      parentRoute: typeof AuthenticatedUserImport
    }
    '/_authenticated-user/superuser/afpant/$orgNumber/intensjonsmelding/$intentionMessageId/': {
      id: '/_authenticated-user/superuser/afpant/$orgNumber/intensjonsmelding/$intentionMessageId/'
      path: '/superuser/afpant/$orgNumber/intensjonsmelding/$intentionMessageId'
      fullPath: '/superuser/afpant/$orgNumber/intensjonsmelding/$intentionMessageId'
      preLoaderRoute: typeof AuthenticatedUserSuperuserAfpantOrgNumberIntensjonsmeldingIntentionMessageIdIndexImport
      parentRoute: typeof AuthenticatedUserImport
    }
    '/_authenticated-user/superuser/afpant/$orgNumber/intensjonssvar/$intentionMessageResponseId/': {
      id: '/_authenticated-user/superuser/afpant/$orgNumber/intensjonssvar/$intentionMessageResponseId/'
      path: '/superuser/afpant/$orgNumber/intensjonssvar/$intentionMessageResponseId'
      fullPath: '/superuser/afpant/$orgNumber/intensjonssvar/$intentionMessageResponseId'
      preLoaderRoute: typeof AuthenticatedUserSuperuserAfpantOrgNumberIntensjonssvarIntentionMessageResponseIdIndexImport
      parentRoute: typeof AuthenticatedUserImport
    }
    '/_authenticated-user/superuser/afpant/$orgNumber/pantedokument/$pantedokumentId/': {
      id: '/_authenticated-user/superuser/afpant/$orgNumber/pantedokument/$pantedokumentId/'
      path: '/superuser/afpant/$orgNumber/pantedokument/$pantedokumentId'
      fullPath: '/superuser/afpant/$orgNumber/pantedokument/$pantedokumentId'
      preLoaderRoute: typeof AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentPantedokumentIdIndexImport
      parentRoute: typeof AuthenticatedUserImport
    }
    '/_authenticated-user/superuser/afpant/$orgNumber/pantedokumentsvar/$pantedokumentResponseId/': {
      id: '/_authenticated-user/superuser/afpant/$orgNumber/pantedokumentsvar/$pantedokumentResponseId/'
      path: '/superuser/afpant/$orgNumber/pantedokumentsvar/$pantedokumentResponseId'
      fullPath: '/superuser/afpant/$orgNumber/pantedokumentsvar/$pantedokumentResponseId'
      preLoaderRoute: typeof AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentsvarPantedokumentResponseIdIndexImport
      parentRoute: typeof AuthenticatedUserImport
    }
    '/_authenticated-user/superuser/afpant/$orgNumber/utboksfil/$outboxFileId/': {
      id: '/_authenticated-user/superuser/afpant/$orgNumber/utboksfil/$outboxFileId/'
      path: '/superuser/afpant/$orgNumber/utboksfil/$outboxFileId'
      fullPath: '/superuser/afpant/$orgNumber/utboksfil/$outboxFileId'
      preLoaderRoute: typeof AuthenticatedUserSuperuserAfpantOrgNumberUtboksfilOutboxFileIdIndexImport
      parentRoute: typeof AuthenticatedUserImport
    }
  }
}

// Create and export the route tree

interface AuthenticatedActorRouteChildren {
  AuthenticatedActorSignerIndexRoute: typeof AuthenticatedActorSignerIndexRoute
}

const AuthenticatedActorRouteChildren: AuthenticatedActorRouteChildren = {
  AuthenticatedActorSignerIndexRoute: AuthenticatedActorSignerIndexRoute,
}

const AuthenticatedActorRouteWithChildren =
  AuthenticatedActorRoute._addFileChildren(AuthenticatedActorRouteChildren)

interface AuthenticatedUserRouteChildren {
  AuthenticatedUserSmsMeldingerIndexRoute: typeof AuthenticatedUserSmsMeldingerIndexRoute
  AuthenticatedUserOppdragTluxCaseIdIndexRoute: typeof AuthenticatedUserOppdragTluxCaseIdIndexRoute
  AuthenticatedUserSuperuserAfpantIndexRoute: typeof AuthenticatedUserSuperuserAfpantIndexRoute
  AuthenticatedUserSuperuserRapporterIndexRoute: typeof AuthenticatedUserSuperuserRapporterIndexRoute
  AuthenticatedUserSuperuserStatistikkIndexRoute: typeof AuthenticatedUserSuperuserStatistikkIndexRoute
  AuthenticatedUserSuperuserTinglysingIndexRoute: typeof AuthenticatedUserSuperuserTinglysingIndexRoute
  AuthenticatedUserOppdragTluxCaseIdOpprettHjemmelserklringIndexRoute: typeof AuthenticatedUserOppdragTluxCaseIdOpprettHjemmelserklringIndexRoute
  AuthenticatedUserOppdragTluxCaseIdOpprettSikringIndexRoute: typeof AuthenticatedUserOppdragTluxCaseIdOpprettSikringIndexRoute
  AuthenticatedUserOppdragTluxCaseIdOpprettSkjteIndexRoute: typeof AuthenticatedUserOppdragTluxCaseIdOpprettSkjteIndexRoute
  AuthenticatedUserOppdragTluxCaseIdOpprettSlettingIndexRoute: typeof AuthenticatedUserOppdragTluxCaseIdOpprettSlettingIndexRoute
  AuthenticatedUserSuperuserAfpantOrgNumberIndexRoute: typeof AuthenticatedUserSuperuserAfpantOrgNumberIndexRoute
  AuthenticatedUserOppdragTluxCaseIdHjemmelserklringHjemmelserklringIdIndexRoute: typeof AuthenticatedUserOppdragTluxCaseIdHjemmelserklringHjemmelserklringIdIndexRoute
  AuthenticatedUserOppdragTluxCaseIdSikringSikringIdIndexRoute: typeof AuthenticatedUserOppdragTluxCaseIdSikringSikringIdIndexRoute
  AuthenticatedUserOppdragTluxCaseIdSkjteSkjteIdIndexRoute: typeof AuthenticatedUserOppdragTluxCaseIdSkjteSkjteIdIndexRoute
  AuthenticatedUserOppdragTluxCaseIdSlettingSlettingIdIndexRoute: typeof AuthenticatedUserOppdragTluxCaseIdSlettingSlettingIdIndexRoute
  AuthenticatedUserSuperuserAfpantOrgNumberInnboksfilInboxFileIdIndexRoute: typeof AuthenticatedUserSuperuserAfpantOrgNumberInnboksfilInboxFileIdIndexRoute
  AuthenticatedUserSuperuserAfpantOrgNumberIntensjonsmeldingIntentionMessageIdIndexRoute: typeof AuthenticatedUserSuperuserAfpantOrgNumberIntensjonsmeldingIntentionMessageIdIndexRoute
  AuthenticatedUserSuperuserAfpantOrgNumberIntensjonssvarIntentionMessageResponseIdIndexRoute: typeof AuthenticatedUserSuperuserAfpantOrgNumberIntensjonssvarIntentionMessageResponseIdIndexRoute
  AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentPantedokumentIdIndexRoute: typeof AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentPantedokumentIdIndexRoute
  AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentsvarPantedokumentResponseIdIndexRoute: typeof AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentsvarPantedokumentResponseIdIndexRoute
  AuthenticatedUserSuperuserAfpantOrgNumberUtboksfilOutboxFileIdIndexRoute: typeof AuthenticatedUserSuperuserAfpantOrgNumberUtboksfilOutboxFileIdIndexRoute
}

const AuthenticatedUserRouteChildren: AuthenticatedUserRouteChildren = {
  AuthenticatedUserSmsMeldingerIndexRoute:
    AuthenticatedUserSmsMeldingerIndexRoute,
  AuthenticatedUserOppdragTluxCaseIdIndexRoute:
    AuthenticatedUserOppdragTluxCaseIdIndexRoute,
  AuthenticatedUserSuperuserAfpantIndexRoute:
    AuthenticatedUserSuperuserAfpantIndexRoute,
  AuthenticatedUserSuperuserRapporterIndexRoute:
    AuthenticatedUserSuperuserRapporterIndexRoute,
  AuthenticatedUserSuperuserStatistikkIndexRoute:
    AuthenticatedUserSuperuserStatistikkIndexRoute,
  AuthenticatedUserSuperuserTinglysingIndexRoute:
    AuthenticatedUserSuperuserTinglysingIndexRoute,
  AuthenticatedUserOppdragTluxCaseIdOpprettHjemmelserklringIndexRoute:
    AuthenticatedUserOppdragTluxCaseIdOpprettHjemmelserklringIndexRoute,
  AuthenticatedUserOppdragTluxCaseIdOpprettSikringIndexRoute:
    AuthenticatedUserOppdragTluxCaseIdOpprettSikringIndexRoute,
  AuthenticatedUserOppdragTluxCaseIdOpprettSkjteIndexRoute:
    AuthenticatedUserOppdragTluxCaseIdOpprettSkjteIndexRoute,
  AuthenticatedUserOppdragTluxCaseIdOpprettSlettingIndexRoute:
    AuthenticatedUserOppdragTluxCaseIdOpprettSlettingIndexRoute,
  AuthenticatedUserSuperuserAfpantOrgNumberIndexRoute:
    AuthenticatedUserSuperuserAfpantOrgNumberIndexRoute,
  AuthenticatedUserOppdragTluxCaseIdHjemmelserklringHjemmelserklringIdIndexRoute:
    AuthenticatedUserOppdragTluxCaseIdHjemmelserklringHjemmelserklringIdIndexRoute,
  AuthenticatedUserOppdragTluxCaseIdSikringSikringIdIndexRoute:
    AuthenticatedUserOppdragTluxCaseIdSikringSikringIdIndexRoute,
  AuthenticatedUserOppdragTluxCaseIdSkjteSkjteIdIndexRoute:
    AuthenticatedUserOppdragTluxCaseIdSkjteSkjteIdIndexRoute,
  AuthenticatedUserOppdragTluxCaseIdSlettingSlettingIdIndexRoute:
    AuthenticatedUserOppdragTluxCaseIdSlettingSlettingIdIndexRoute,
  AuthenticatedUserSuperuserAfpantOrgNumberInnboksfilInboxFileIdIndexRoute:
    AuthenticatedUserSuperuserAfpantOrgNumberInnboksfilInboxFileIdIndexRoute,
  AuthenticatedUserSuperuserAfpantOrgNumberIntensjonsmeldingIntentionMessageIdIndexRoute:
    AuthenticatedUserSuperuserAfpantOrgNumberIntensjonsmeldingIntentionMessageIdIndexRoute,
  AuthenticatedUserSuperuserAfpantOrgNumberIntensjonssvarIntentionMessageResponseIdIndexRoute:
    AuthenticatedUserSuperuserAfpantOrgNumberIntensjonssvarIntentionMessageResponseIdIndexRoute,
  AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentPantedokumentIdIndexRoute:
    AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentPantedokumentIdIndexRoute,
  AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentsvarPantedokumentResponseIdIndexRoute:
    AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentsvarPantedokumentResponseIdIndexRoute,
  AuthenticatedUserSuperuserAfpantOrgNumberUtboksfilOutboxFileIdIndexRoute:
    AuthenticatedUserSuperuserAfpantOrgNumberUtboksfilOutboxFileIdIndexRoute,
}

const AuthenticatedUserRouteWithChildren =
  AuthenticatedUserRoute._addFileChildren(AuthenticatedUserRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof AuthenticatedUserRouteWithChildren
  '/login': typeof LoginIndexRoute
  '/ny-bruker': typeof NyBrukerIndexRoute
  '/signer': typeof AuthenticatedActorSignerIndexRoute
  '/sms-meldinger': typeof AuthenticatedUserSmsMeldingerIndexRoute
  '/oppdrag/$tluxCaseId': typeof AuthenticatedUserOppdragTluxCaseIdIndexRoute
  '/superuser/afpant': typeof AuthenticatedUserSuperuserAfpantIndexRoute
  '/superuser/rapporter': typeof AuthenticatedUserSuperuserRapporterIndexRoute
  '/superuser/statistikk': typeof AuthenticatedUserSuperuserStatistikkIndexRoute
  '/superuser/tinglysing': typeof AuthenticatedUserSuperuserTinglysingIndexRoute
  '/oppdrag/$tluxCaseId/opprett-hjemmelserklæring': typeof AuthenticatedUserOppdragTluxCaseIdOpprettHjemmelserklringIndexRoute
  '/oppdrag/$tluxCaseId/opprett-sikring': typeof AuthenticatedUserOppdragTluxCaseIdOpprettSikringIndexRoute
  '/oppdrag/$tluxCaseId/opprett-skjøte': typeof AuthenticatedUserOppdragTluxCaseIdOpprettSkjteIndexRoute
  '/oppdrag/$tluxCaseId/opprett-sletting': typeof AuthenticatedUserOppdragTluxCaseIdOpprettSlettingIndexRoute
  '/superuser/afpant/$orgNumber': typeof AuthenticatedUserSuperuserAfpantOrgNumberIndexRoute
  '/oppdrag/$tluxCaseId/hjemmelserklæring/$hjemmelserklæringId': typeof AuthenticatedUserOppdragTluxCaseIdHjemmelserklringHjemmelserklringIdIndexRoute
  '/oppdrag/$tluxCaseId/sikring/$sikringId': typeof AuthenticatedUserOppdragTluxCaseIdSikringSikringIdIndexRoute
  '/oppdrag/$tluxCaseId/skjøte/$skjøteId': typeof AuthenticatedUserOppdragTluxCaseIdSkjteSkjteIdIndexRoute
  '/oppdrag/$tluxCaseId/sletting/$slettingId': typeof AuthenticatedUserOppdragTluxCaseIdSlettingSlettingIdIndexRoute
  '/superuser/afpant/$orgNumber/innboksfil/$inboxFileId': typeof AuthenticatedUserSuperuserAfpantOrgNumberInnboksfilInboxFileIdIndexRoute
  '/superuser/afpant/$orgNumber/intensjonsmelding/$intentionMessageId': typeof AuthenticatedUserSuperuserAfpantOrgNumberIntensjonsmeldingIntentionMessageIdIndexRoute
  '/superuser/afpant/$orgNumber/intensjonssvar/$intentionMessageResponseId': typeof AuthenticatedUserSuperuserAfpantOrgNumberIntensjonssvarIntentionMessageResponseIdIndexRoute
  '/superuser/afpant/$orgNumber/pantedokument/$pantedokumentId': typeof AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentPantedokumentIdIndexRoute
  '/superuser/afpant/$orgNumber/pantedokumentsvar/$pantedokumentResponseId': typeof AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentsvarPantedokumentResponseIdIndexRoute
  '/superuser/afpant/$orgNumber/utboksfil/$outboxFileId': typeof AuthenticatedUserSuperuserAfpantOrgNumberUtboksfilOutboxFileIdIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof AuthenticatedUserRouteWithChildren
  '/login': typeof LoginIndexRoute
  '/ny-bruker': typeof NyBrukerIndexRoute
  '/signer': typeof AuthenticatedActorSignerIndexRoute
  '/sms-meldinger': typeof AuthenticatedUserSmsMeldingerIndexRoute
  '/oppdrag/$tluxCaseId': typeof AuthenticatedUserOppdragTluxCaseIdIndexRoute
  '/superuser/afpant': typeof AuthenticatedUserSuperuserAfpantIndexRoute
  '/superuser/rapporter': typeof AuthenticatedUserSuperuserRapporterIndexRoute
  '/superuser/statistikk': typeof AuthenticatedUserSuperuserStatistikkIndexRoute
  '/superuser/tinglysing': typeof AuthenticatedUserSuperuserTinglysingIndexRoute
  '/oppdrag/$tluxCaseId/opprett-hjemmelserklæring': typeof AuthenticatedUserOppdragTluxCaseIdOpprettHjemmelserklringIndexRoute
  '/oppdrag/$tluxCaseId/opprett-sikring': typeof AuthenticatedUserOppdragTluxCaseIdOpprettSikringIndexRoute
  '/oppdrag/$tluxCaseId/opprett-skjøte': typeof AuthenticatedUserOppdragTluxCaseIdOpprettSkjteIndexRoute
  '/oppdrag/$tluxCaseId/opprett-sletting': typeof AuthenticatedUserOppdragTluxCaseIdOpprettSlettingIndexRoute
  '/superuser/afpant/$orgNumber': typeof AuthenticatedUserSuperuserAfpantOrgNumberIndexRoute
  '/oppdrag/$tluxCaseId/hjemmelserklæring/$hjemmelserklæringId': typeof AuthenticatedUserOppdragTluxCaseIdHjemmelserklringHjemmelserklringIdIndexRoute
  '/oppdrag/$tluxCaseId/sikring/$sikringId': typeof AuthenticatedUserOppdragTluxCaseIdSikringSikringIdIndexRoute
  '/oppdrag/$tluxCaseId/skjøte/$skjøteId': typeof AuthenticatedUserOppdragTluxCaseIdSkjteSkjteIdIndexRoute
  '/oppdrag/$tluxCaseId/sletting/$slettingId': typeof AuthenticatedUserOppdragTluxCaseIdSlettingSlettingIdIndexRoute
  '/superuser/afpant/$orgNumber/innboksfil/$inboxFileId': typeof AuthenticatedUserSuperuserAfpantOrgNumberInnboksfilInboxFileIdIndexRoute
  '/superuser/afpant/$orgNumber/intensjonsmelding/$intentionMessageId': typeof AuthenticatedUserSuperuserAfpantOrgNumberIntensjonsmeldingIntentionMessageIdIndexRoute
  '/superuser/afpant/$orgNumber/intensjonssvar/$intentionMessageResponseId': typeof AuthenticatedUserSuperuserAfpantOrgNumberIntensjonssvarIntentionMessageResponseIdIndexRoute
  '/superuser/afpant/$orgNumber/pantedokument/$pantedokumentId': typeof AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentPantedokumentIdIndexRoute
  '/superuser/afpant/$orgNumber/pantedokumentsvar/$pantedokumentResponseId': typeof AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentsvarPantedokumentResponseIdIndexRoute
  '/superuser/afpant/$orgNumber/utboksfil/$outboxFileId': typeof AuthenticatedUserSuperuserAfpantOrgNumberUtboksfilOutboxFileIdIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_authenticated-actor': typeof AuthenticatedActorRouteWithChildren
  '/_authenticated-user': typeof AuthenticatedUserRouteWithChildren
  '/login/': typeof LoginIndexRoute
  '/ny-bruker/': typeof NyBrukerIndexRoute
  '/_authenticated-actor/signer/': typeof AuthenticatedActorSignerIndexRoute
  '/_authenticated-user/sms-meldinger/': typeof AuthenticatedUserSmsMeldingerIndexRoute
  '/_authenticated-user/oppdrag/$tluxCaseId/': typeof AuthenticatedUserOppdragTluxCaseIdIndexRoute
  '/_authenticated-user/superuser/afpant/': typeof AuthenticatedUserSuperuserAfpantIndexRoute
  '/_authenticated-user/superuser/rapporter/': typeof AuthenticatedUserSuperuserRapporterIndexRoute
  '/_authenticated-user/superuser/statistikk/': typeof AuthenticatedUserSuperuserStatistikkIndexRoute
  '/_authenticated-user/superuser/tinglysing/': typeof AuthenticatedUserSuperuserTinglysingIndexRoute
  '/_authenticated-user/oppdrag/$tluxCaseId/opprett-hjemmelserklæring/': typeof AuthenticatedUserOppdragTluxCaseIdOpprettHjemmelserklringIndexRoute
  '/_authenticated-user/oppdrag/$tluxCaseId/opprett-sikring/': typeof AuthenticatedUserOppdragTluxCaseIdOpprettSikringIndexRoute
  '/_authenticated-user/oppdrag/$tluxCaseId/opprett-skjøte/': typeof AuthenticatedUserOppdragTluxCaseIdOpprettSkjteIndexRoute
  '/_authenticated-user/oppdrag/$tluxCaseId/opprett-sletting/': typeof AuthenticatedUserOppdragTluxCaseIdOpprettSlettingIndexRoute
  '/_authenticated-user/superuser/afpant/$orgNumber/': typeof AuthenticatedUserSuperuserAfpantOrgNumberIndexRoute
  '/_authenticated-user/oppdrag/$tluxCaseId/hjemmelserklæring/$hjemmelserklæringId/': typeof AuthenticatedUserOppdragTluxCaseIdHjemmelserklringHjemmelserklringIdIndexRoute
  '/_authenticated-user/oppdrag/$tluxCaseId/sikring/$sikringId/': typeof AuthenticatedUserOppdragTluxCaseIdSikringSikringIdIndexRoute
  '/_authenticated-user/oppdrag/$tluxCaseId/skjøte/$skjøteId/': typeof AuthenticatedUserOppdragTluxCaseIdSkjteSkjteIdIndexRoute
  '/_authenticated-user/oppdrag/$tluxCaseId/sletting/$slettingId/': typeof AuthenticatedUserOppdragTluxCaseIdSlettingSlettingIdIndexRoute
  '/_authenticated-user/superuser/afpant/$orgNumber/innboksfil/$inboxFileId/': typeof AuthenticatedUserSuperuserAfpantOrgNumberInnboksfilInboxFileIdIndexRoute
  '/_authenticated-user/superuser/afpant/$orgNumber/intensjonsmelding/$intentionMessageId/': typeof AuthenticatedUserSuperuserAfpantOrgNumberIntensjonsmeldingIntentionMessageIdIndexRoute
  '/_authenticated-user/superuser/afpant/$orgNumber/intensjonssvar/$intentionMessageResponseId/': typeof AuthenticatedUserSuperuserAfpantOrgNumberIntensjonssvarIntentionMessageResponseIdIndexRoute
  '/_authenticated-user/superuser/afpant/$orgNumber/pantedokument/$pantedokumentId/': typeof AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentPantedokumentIdIndexRoute
  '/_authenticated-user/superuser/afpant/$orgNumber/pantedokumentsvar/$pantedokumentResponseId/': typeof AuthenticatedUserSuperuserAfpantOrgNumberPantedokumentsvarPantedokumentResponseIdIndexRoute
  '/_authenticated-user/superuser/afpant/$orgNumber/utboksfil/$outboxFileId/': typeof AuthenticatedUserSuperuserAfpantOrgNumberUtboksfilOutboxFileIdIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/login'
    | '/ny-bruker'
    | '/signer'
    | '/sms-meldinger'
    | '/oppdrag/$tluxCaseId'
    | '/superuser/afpant'
    | '/superuser/rapporter'
    | '/superuser/statistikk'
    | '/superuser/tinglysing'
    | '/oppdrag/$tluxCaseId/opprett-hjemmelserklæring'
    | '/oppdrag/$tluxCaseId/opprett-sikring'
    | '/oppdrag/$tluxCaseId/opprett-skjøte'
    | '/oppdrag/$tluxCaseId/opprett-sletting'
    | '/superuser/afpant/$orgNumber'
    | '/oppdrag/$tluxCaseId/hjemmelserklæring/$hjemmelserklæringId'
    | '/oppdrag/$tluxCaseId/sikring/$sikringId'
    | '/oppdrag/$tluxCaseId/skjøte/$skjøteId'
    | '/oppdrag/$tluxCaseId/sletting/$slettingId'
    | '/superuser/afpant/$orgNumber/innboksfil/$inboxFileId'
    | '/superuser/afpant/$orgNumber/intensjonsmelding/$intentionMessageId'
    | '/superuser/afpant/$orgNumber/intensjonssvar/$intentionMessageResponseId'
    | '/superuser/afpant/$orgNumber/pantedokument/$pantedokumentId'
    | '/superuser/afpant/$orgNumber/pantedokumentsvar/$pantedokumentResponseId'
    | '/superuser/afpant/$orgNumber/utboksfil/$outboxFileId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/login'
    | '/ny-bruker'
    | '/signer'
    | '/sms-meldinger'
    | '/oppdrag/$tluxCaseId'
    | '/superuser/afpant'
    | '/superuser/rapporter'
    | '/superuser/statistikk'
    | '/superuser/tinglysing'
    | '/oppdrag/$tluxCaseId/opprett-hjemmelserklæring'
    | '/oppdrag/$tluxCaseId/opprett-sikring'
    | '/oppdrag/$tluxCaseId/opprett-skjøte'
    | '/oppdrag/$tluxCaseId/opprett-sletting'
    | '/superuser/afpant/$orgNumber'
    | '/oppdrag/$tluxCaseId/hjemmelserklæring/$hjemmelserklæringId'
    | '/oppdrag/$tluxCaseId/sikring/$sikringId'
    | '/oppdrag/$tluxCaseId/skjøte/$skjøteId'
    | '/oppdrag/$tluxCaseId/sletting/$slettingId'
    | '/superuser/afpant/$orgNumber/innboksfil/$inboxFileId'
    | '/superuser/afpant/$orgNumber/intensjonsmelding/$intentionMessageId'
    | '/superuser/afpant/$orgNumber/intensjonssvar/$intentionMessageResponseId'
    | '/superuser/afpant/$orgNumber/pantedokument/$pantedokumentId'
    | '/superuser/afpant/$orgNumber/pantedokumentsvar/$pantedokumentResponseId'
    | '/superuser/afpant/$orgNumber/utboksfil/$outboxFileId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated-actor'
    | '/_authenticated-user'
    | '/login/'
    | '/ny-bruker/'
    | '/_authenticated-actor/signer/'
    | '/_authenticated-user/sms-meldinger/'
    | '/_authenticated-user/oppdrag/$tluxCaseId/'
    | '/_authenticated-user/superuser/afpant/'
    | '/_authenticated-user/superuser/rapporter/'
    | '/_authenticated-user/superuser/statistikk/'
    | '/_authenticated-user/superuser/tinglysing/'
    | '/_authenticated-user/oppdrag/$tluxCaseId/opprett-hjemmelserklæring/'
    | '/_authenticated-user/oppdrag/$tluxCaseId/opprett-sikring/'
    | '/_authenticated-user/oppdrag/$tluxCaseId/opprett-skjøte/'
    | '/_authenticated-user/oppdrag/$tluxCaseId/opprett-sletting/'
    | '/_authenticated-user/superuser/afpant/$orgNumber/'
    | '/_authenticated-user/oppdrag/$tluxCaseId/hjemmelserklæring/$hjemmelserklæringId/'
    | '/_authenticated-user/oppdrag/$tluxCaseId/sikring/$sikringId/'
    | '/_authenticated-user/oppdrag/$tluxCaseId/skjøte/$skjøteId/'
    | '/_authenticated-user/oppdrag/$tluxCaseId/sletting/$slettingId/'
    | '/_authenticated-user/superuser/afpant/$orgNumber/innboksfil/$inboxFileId/'
    | '/_authenticated-user/superuser/afpant/$orgNumber/intensjonsmelding/$intentionMessageId/'
    | '/_authenticated-user/superuser/afpant/$orgNumber/intensjonssvar/$intentionMessageResponseId/'
    | '/_authenticated-user/superuser/afpant/$orgNumber/pantedokument/$pantedokumentId/'
    | '/_authenticated-user/superuser/afpant/$orgNumber/pantedokumentsvar/$pantedokumentResponseId/'
    | '/_authenticated-user/superuser/afpant/$orgNumber/utboksfil/$outboxFileId/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedActorRoute: typeof AuthenticatedActorRouteWithChildren
  AuthenticatedUserRoute: typeof AuthenticatedUserRouteWithChildren
  LoginIndexRoute: typeof LoginIndexRoute
  NyBrukerIndexRoute: typeof NyBrukerIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedActorRoute: AuthenticatedActorRouteWithChildren,
  AuthenticatedUserRoute: AuthenticatedUserRouteWithChildren,
  LoginIndexRoute: LoginIndexRoute,
  NyBrukerIndexRoute: NyBrukerIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_authenticated-actor",
        "/_authenticated-user",
        "/login/",
        "/ny-bruker/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_authenticated-actor": {
      "filePath": "_authenticated-actor.tsx",
      "children": [
        "/_authenticated-actor/signer/"
      ]
    },
    "/_authenticated-user": {
      "filePath": "_authenticated-user.tsx",
      "children": [
        "/_authenticated-user/sms-meldinger/",
        "/_authenticated-user/oppdrag/$tluxCaseId/",
        "/_authenticated-user/superuser/afpant/",
        "/_authenticated-user/superuser/rapporter/",
        "/_authenticated-user/superuser/statistikk/",
        "/_authenticated-user/superuser/tinglysing/",
        "/_authenticated-user/oppdrag/$tluxCaseId/opprett-hjemmelserklæring/",
        "/_authenticated-user/oppdrag/$tluxCaseId/opprett-sikring/",
        "/_authenticated-user/oppdrag/$tluxCaseId/opprett-skjøte/",
        "/_authenticated-user/oppdrag/$tluxCaseId/opprett-sletting/",
        "/_authenticated-user/superuser/afpant/$orgNumber/",
        "/_authenticated-user/oppdrag/$tluxCaseId/hjemmelserklæring/$hjemmelserklæringId/",
        "/_authenticated-user/oppdrag/$tluxCaseId/sikring/$sikringId/",
        "/_authenticated-user/oppdrag/$tluxCaseId/skjøte/$skjøteId/",
        "/_authenticated-user/oppdrag/$tluxCaseId/sletting/$slettingId/",
        "/_authenticated-user/superuser/afpant/$orgNumber/innboksfil/$inboxFileId/",
        "/_authenticated-user/superuser/afpant/$orgNumber/intensjonsmelding/$intentionMessageId/",
        "/_authenticated-user/superuser/afpant/$orgNumber/intensjonssvar/$intentionMessageResponseId/",
        "/_authenticated-user/superuser/afpant/$orgNumber/pantedokument/$pantedokumentId/",
        "/_authenticated-user/superuser/afpant/$orgNumber/pantedokumentsvar/$pantedokumentResponseId/",
        "/_authenticated-user/superuser/afpant/$orgNumber/utboksfil/$outboxFileId/"
      ]
    },
    "/login/": {
      "filePath": "login/index.tsx"
    },
    "/ny-bruker/": {
      "filePath": "ny-bruker/index.tsx"
    },
    "/_authenticated-actor/signer/": {
      "filePath": "_authenticated-actor/signer/index.tsx",
      "parent": "/_authenticated-actor"
    },
    "/_authenticated-user/sms-meldinger/": {
      "filePath": "_authenticated-user/sms-meldinger/index.tsx",
      "parent": "/_authenticated-user"
    },
    "/_authenticated-user/oppdrag/$tluxCaseId/": {
      "filePath": "_authenticated-user/oppdrag/$tluxCaseId/index.tsx",
      "parent": "/_authenticated-user"
    },
    "/_authenticated-user/superuser/afpant/": {
      "filePath": "_authenticated-user/superuser/afpant/index.tsx",
      "parent": "/_authenticated-user"
    },
    "/_authenticated-user/superuser/rapporter/": {
      "filePath": "_authenticated-user/superuser/rapporter/index.tsx",
      "parent": "/_authenticated-user"
    },
    "/_authenticated-user/superuser/statistikk/": {
      "filePath": "_authenticated-user/superuser/statistikk/index.tsx",
      "parent": "/_authenticated-user"
    },
    "/_authenticated-user/superuser/tinglysing/": {
      "filePath": "_authenticated-user/superuser/tinglysing/index.tsx",
      "parent": "/_authenticated-user"
    },
    "/_authenticated-user/oppdrag/$tluxCaseId/opprett-hjemmelserklæring/": {
      "filePath": "_authenticated-user/oppdrag/$tluxCaseId/opprett-hjemmelserklæring/index.tsx",
      "parent": "/_authenticated-user"
    },
    "/_authenticated-user/oppdrag/$tluxCaseId/opprett-sikring/": {
      "filePath": "_authenticated-user/oppdrag/$tluxCaseId/opprett-sikring/index.tsx",
      "parent": "/_authenticated-user"
    },
    "/_authenticated-user/oppdrag/$tluxCaseId/opprett-skjøte/": {
      "filePath": "_authenticated-user/oppdrag/$tluxCaseId/opprett-skjøte/index.tsx",
      "parent": "/_authenticated-user"
    },
    "/_authenticated-user/oppdrag/$tluxCaseId/opprett-sletting/": {
      "filePath": "_authenticated-user/oppdrag/$tluxCaseId/opprett-sletting/index.tsx",
      "parent": "/_authenticated-user"
    },
    "/_authenticated-user/superuser/afpant/$orgNumber/": {
      "filePath": "_authenticated-user/superuser/afpant/$orgNumber/index.tsx",
      "parent": "/_authenticated-user"
    },
    "/_authenticated-user/oppdrag/$tluxCaseId/hjemmelserklæring/$hjemmelserklæringId/": {
      "filePath": "_authenticated-user/oppdrag/$tluxCaseId/hjemmelserklæring/$hjemmelserklæringId/index.tsx",
      "parent": "/_authenticated-user"
    },
    "/_authenticated-user/oppdrag/$tluxCaseId/sikring/$sikringId/": {
      "filePath": "_authenticated-user/oppdrag/$tluxCaseId/sikring/$sikringId/index.tsx",
      "parent": "/_authenticated-user"
    },
    "/_authenticated-user/oppdrag/$tluxCaseId/skjøte/$skjøteId/": {
      "filePath": "_authenticated-user/oppdrag/$tluxCaseId/skjøte/$skjøteId/index.tsx",
      "parent": "/_authenticated-user"
    },
    "/_authenticated-user/oppdrag/$tluxCaseId/sletting/$slettingId/": {
      "filePath": "_authenticated-user/oppdrag/$tluxCaseId/sletting/$slettingId/index.tsx",
      "parent": "/_authenticated-user"
    },
    "/_authenticated-user/superuser/afpant/$orgNumber/innboksfil/$inboxFileId/": {
      "filePath": "_authenticated-user/superuser/afpant/$orgNumber/innboksfil/$inboxFileId/index.tsx",
      "parent": "/_authenticated-user"
    },
    "/_authenticated-user/superuser/afpant/$orgNumber/intensjonsmelding/$intentionMessageId/": {
      "filePath": "_authenticated-user/superuser/afpant/$orgNumber/intensjonsmelding/$intentionMessageId/index.tsx",
      "parent": "/_authenticated-user"
    },
    "/_authenticated-user/superuser/afpant/$orgNumber/intensjonssvar/$intentionMessageResponseId/": {
      "filePath": "_authenticated-user/superuser/afpant/$orgNumber/intensjonssvar/$intentionMessageResponseId/index.tsx",
      "parent": "/_authenticated-user"
    },
    "/_authenticated-user/superuser/afpant/$orgNumber/pantedokument/$pantedokumentId/": {
      "filePath": "_authenticated-user/superuser/afpant/$orgNumber/pantedokument/$pantedokumentId/index.tsx",
      "parent": "/_authenticated-user"
    },
    "/_authenticated-user/superuser/afpant/$orgNumber/pantedokumentsvar/$pantedokumentResponseId/": {
      "filePath": "_authenticated-user/superuser/afpant/$orgNumber/pantedokumentsvar/$pantedokumentResponseId/index.tsx",
      "parent": "/_authenticated-user"
    },
    "/_authenticated-user/superuser/afpant/$orgNumber/utboksfil/$outboxFileId/": {
      "filePath": "_authenticated-user/superuser/afpant/$orgNumber/utboksfil/$outboxFileId/index.tsx",
      "parent": "/_authenticated-user"
    }
  }
}
ROUTE_MANIFEST_END */
